import React, { useState } from "react";
import ReportsApi from "~/admin/apis/reports.api";
import PageDataLoader from "~/admin/components/PageDataLoader";
import useDataLoading from "~/admin/hooks/useDataLoading";
import useLayout from "~/hooks/useLayout";
import useMount from "~/hooks/useMount";
import TabBar from "~/admin/components/TabBar";
import ReportsListTab from "./ReportsListTab";
import UsersApi from "~/admin/apis/users.api";
import BlockedListTab from "./BlockedListTab";

export default function ReportedPage() {
  const { setLayout } = useLayout();
  const [activeTab, setActiveTab] = useState("reportedUsers");
  const [reportedUsers, setReportedUsers] = useState([]);
  const [blockedUsers, setBlockedUsers] = useState([]);
  const dataLoading = useDataLoading();
  const tabItems = [
    {
      key: "reportedUsers",
      title: "Signalement",
    },
    {
      key: "blockedUsers",
      title: "Utilisateurs bloqués",
    },
  ];

  useMount(() => {
    setLayout({
      title: "Signalements",
      activeMenuKeys: ["reports"],
    });
    loadData();
  });

  const loadData = async (page = 1) => {
    dataLoading.start();
    setReportedUsers([]);

    let error = null;
    const data = await Promise.all([
      ReportsApi.paginate(page),
      UsersApi.paginateBlocked(),
    ]).catch((e) => {
      error = e;
      return null;
    });

    dataLoading.stop(error);

    if (data) {
      setReportedUsers(data[0]);
      setBlockedUsers(data[1]);
    }
  };

  const searchReportedUsers = async (page = 1) => {
    let reportedUsers = await ReportsApi.paginate(page).catch((e) => {
      return null;
    });

    if (reportedUsers) {
      setReportedUsers(reportedUsers);
    }
  };

  const onPaginateReportedUsers = (page) => {
    searchReportedUsers(page);
  };

  const searchBlockedUsers = async (page = 1) => {
    let blockedUsers = await UsersApi.paginateBlocked(page).catch((e) => {
      return null;
    });

    if (blockedUsers) {
      setReportedUsers(blockedUsers);
    }
  };

  const onPaginateBlockedUsers = (page) => {
    searchBlockedUsers(page);
  };

  const changeTab = (key) => {
    setActiveTab(key);
  };

  return (
    <PageDataLoader isLoading={dataLoading.isLoading}>
      <div className="w-full h-screen text-white flex flex-col">
        <div className="w-full min-h-[60px] border-b-2 border-slate-700 flex justify-between items-center px-10">
          <TabBar
            items={tabItems}
            activeItem={activeTab}
            onChange={changeTab}
          />
          <div className="font-bold text-2xl">Signalements</div>
        </div>
        <div className="p-6 overflow-auto">
          {activeTab === "reportedUsers" && (
            <ReportsListTab
              reportedUsers={reportedUsers}
              onPaginate={onPaginateReportedUsers}
            />
          )}
          {activeTab === "blockedUsers" && (
            <BlockedListTab
              blockedUsers={blockedUsers}
              onPaginate={onPaginateBlockedUsers}
            />
          )}
        </div>
      </div>
    </PageDataLoader>
  );
}
